module.exports = __webpack_public_path__ + "img/logoemi.6e3a23a2.png";